// import { configureStore } from "@reduxjs/toolkit";
// import constants from "./slices/constants";
// import userSlice from "./slices/userManagement"
// import exams from "./slices/exams"
// import contentFeedbackSlice from "./slices/contentFeedback/contentFeedbackSlice";
// import QuestionReviewSlice from "./slices/QuestionReview/QuestionReviewSlice";
// import orderAndPaymentSlice from "./slices/ordersAndPayments/ordersAndPaymentSlice";
// import pendingApprovalSlice from "./slices/pendingApproval";
// import internalUserSlice from "./slices/InternalUsers/InternalUserSlice";
// import questionsDataArraySliceReducer from "./slices/proofReading/questionDataArraySlice";



// export type State = {};

// export const store = configureStore({
//   reducer: {
//     constantSlice: constants,
//     userSlice:userSlice,
//     exams:exams,
//     contentFeedback:contentFeedbackSlice,
//     QuestionReview:QuestionReviewSlice,
//     orderAndPaymentSlice: orderAndPaymentSlice,
//     pendingApprovalSlice:pendingApprovalSlice,
//     internalUserSlice:internalUserSlice,
//     questionsDataArraySlice: questionsDataArraySliceReducer,
//   },
//   middleware: (getDefaultMiddleware) =>
//   getDefaultMiddleware({
//     // thunk: {
//     //   extraArgument: myCustomApiService,
//     // },
//     serializableCheck: false,
//   }),

// });

// export type AppDispatch = typeof store.dispatch;
// export type RootState = ReturnType<typeof store.getState>;

import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { persistReducer, persistStore } from "redux-persist";
import { combineReducers } from "redux";

import constants from "./slices/constants";
import userSlice from "./slices/userManagement";
import exams from "./slices/exams";
import contentFeedbackSlice from "./slices/contentFeedback/contentFeedbackSlice";
import detailedMasterSlice from "./slices/detailedMaster/detailedMasterSlice";
import QuestionReviewSlice from "./slices/QuestionReview/QuestionReviewSlice";
import orderAndPaymentSlice from "./slices/ordersAndPayments/ordersAndPaymentSlice";
import pendingApprovalSlice from "./slices/pendingApproval";
import internalUserSlice from "./slices/InternalUsers/InternalUserSlice";
import questionsDataArraySliceReducer from "./slices/proofReading/questionDataArraySlice";

// ✅ Combine all reducers
const rootReducer = combineReducers({
  constantSlice: constants,
  userSlice: userSlice,
  exams: exams,
  contentFeedback: contentFeedbackSlice,
  detailedMaster: detailedMasterSlice,
  QuestionReview: QuestionReviewSlice,
  orderAndPaymentSlice: orderAndPaymentSlice,
  pendingApprovalSlice: pendingApprovalSlice,
  internalUserSlice: internalUserSlice,
  questionsDataArraySlice: questionsDataArraySliceReducer,
});

// ✅ Persist Config
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["userSlice"], // only persist userSlice (add more if needed)
  // blacklist: ["pendingApprovalSlice"], // slices you DON'T want persisted
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// ✅ Store with Persist Reducer
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// ✅ Persistor
export const persistor = persistStore(store);

// ✅ Types
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
